import React from 'react';
import { QSGContextType } from '../typings/qsg-app';

export const QSGContext = React.createContext<QSGContextType | null>(null);

export function useQSGContext(): QSGContextType {
  const qsgContext = React.useContext(QSGContext);

  if (!qsgContext) {
    throw new Error('No QSG context value was provided.');
  }

  return qsgContext;
}
